module.exports = __webpack_public_path__ + "img/1440.f1877fa6.jpg";